var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDensityComfortable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5C5 7.94771 5.44772 7.5 6 7.5H18C18.5523 7.5 19 7.94772 19 8.5V11.1512C19 11.7034 18.5523 12.1512 18 12.1512H6C5.44772 12.1512 5 11.7034 5 11.1512V8.5Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.0814C5 13.5291 5.44772 13.0814 6 13.0814H18C18.5523 13.0814 19 13.5291 19 14.0814V16.5C19 17.0523 18.5523 17.5 18 17.5H6C5.44772 17.5 5 17.0523 5 16.5V14.0814Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensityComfortable);
export default __webpack_public_path__ + "static/media/density-comfortable.9ff9da9287fabb0bfe8c2dce82a05cd8.svg";
export { ForwardRef as ReactComponent };